import React from 'react';
import './Contact.css';
import Swal from 'sweetalert2';

function Contact() {

  const onSubmitbtn = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
  
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: data
    });
  
    const result = await response.json();
  
    if (result.success) {
      form.reset();
  
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Your message has been successfully sent to AHH International Import & Export Group. Please wait a moment — we’ll get back to you as soon as possible. Thank you for reaching out!',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: 'Something went wrong. Please try again later.',
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK'
      });
    }
  };

  return (
    <div className='contact-page'>
      <section className="contact-hero">
        <div className="container text-center">
          <div className="contact-box">
            <h1 className="contact-heading">C O N T A C T &nbsp; U S</h1>
            <p className="contact-text">
              If you’re interested in finding more about us or the way we run AHH International Group, feel free to get in touch.
              We can also advise you as to what we’re currently harvesting so you can order accordingly.
            </p>
          </div>
        </div>
      </section>

      <div>
        <section className="cont-section">
          <h2 className="text-center text-white display-5 cont">Contact Us</h2>

          <form onSubmit={onSubmitbtn}>
            <input type="hidden" name="access_key" value="ee6edf49-de7d-4b64-a87d-0e17908010d9" />

            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-cont1">
                <div className="container pad">
                  <input
                    type="text"
                    name="name"
                    className="form-control lead"
                    placeholder="Enter Your Full Name"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    className="form-control lead"
                    placeholder="Enter Your E-Mail"
                    required
                  />
                  <input
                    type="tel"
                    name="phone"
                    className="form-control lead"
                    placeholder="Enter Your Phone Number"
                  />
                  <input
                    type="text"
                    name="subject"
                    className="form-control lead"
                    placeholder="Enter Your Subject"
                  />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-cont2">
                <div className="container pad">
                  <textarea
                    name="message"
                    className="form-control lead"
                    rows={7}
                    placeholder="Enter Your Message..."
                    required
                  />
                  <div className="text-center">
                    <button type="submit" className="btn-cont lead mt-4">
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      <div className="map-container">
        <iframe
          title="AHH International Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.777888407372!2d74.34949139999999!3d31.5302598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391905aa7f2879af%3A0xb8e6011d66282543!2sAHH%20International%20Import%26Export!5e0!3m2!1sen!2s!4v1744611014023!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}

export default Contact;
